module.exports = __webpack_public_path__ + "img/img-12.8e29d557.webp";